import { jsx as _jsx } from "react/jsx-runtime";
import { getConfig } from "@jti/fe-common";
import OrderBundleItem from "./OrderBundleItem";
import OrderItem from "./OrderItem";
const OrderItems = ({ className, items, isFreeTrial }) => (_jsx("div", { className: className, children: items?.map((item) => item?.product_type === "bundle" && getConfig().displayBundleSelectedItems ? (_jsx(OrderBundleItem, { item: item, isFreeTrial: isFreeTrial }, item.item_id)) : (_jsx(OrderItem, { item: item, isFreeTrial: isFreeTrial }, item.item_id))) }));
export default OrderItems;
//# sourceMappingURL=OrderItems.js.map